import { render, staticRenderFns } from "./mynav.vue?vue&type=template&id=dbb06928&"
import script from "./mynav.vue?vue&type=script&lang=js&"
export * from "./mynav.vue?vue&type=script&lang=js&"
import style0 from "./mynav.vue?vue&type=style&index=0&id=dbb06928&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports